import { EventEmitter } from '@timing71/common';
import { MARSHAL_POST_LOCATIONS } from './nurburgring.js';

const TOKEN_SPLIT_REGEX = /^(?<field>[a-z]+([0-9]+_)?)((?<idx>[0-9]+)):=(?<value>.*)?$/;

const parseObjects = (raw) => {
  const tokens = raw.slice(11).split(';');
  const result = {};

  tokens.forEach(
    token => {
      const split = token.match(TOKEN_SPLIT_REGEX);
      if (split) {
        const { field, idx, value } = split.groups;
        if (idx) {
          if (!result[idx]) {
            result[idx] = {}
          }
          result[idx][field] = value;
        }
      }
    }
  )

  return result;
}

export class GPSAuge extends EventEmitter {
  constructor(connectionService, overIPApp='IPHNGR24') { // or IPHADAC24H
    super();
    this.connectionService = connectionService;

    this.marshalPostAddressUrl = `https://racingios.apioverip.de/?action=list&gps_system=iOS_Racing&gps_version=2.60&module=geoobject&nozlib=1&overipapp=${overIPApp}&type=address`;
    this.marshalPostIDUrl = `https://racingios.apioverip.de/?action=list&gps_system=iOS_Racing&gps_version=2.60&module=rule&nozlib=1&overipapp=${overIPApp}`;
    this.activeZonesUrl = `https://api-racingios.gpsoverip.de/v1/racing/rules/active?overipapp=${overIPApp}&ts=`;

    this._names = {};
    this._marshalPosts = {};
    this._timeout = null;

    this.start = this.start.bind(this);
    this.updateZones = this.updateZones.bind(this);
    this.stop = this.stop.bind(this);

  }

  async start() {
    const postsRaw = await this.connectionService.fetch(this.marshalPostAddressUrl);
    const posts = parseObjects(postsRaw);

    Object.values(posts).forEach(
      post => {
        if (post.geoobjectid) {
          this._names[post.geoobjectid] = post.name ? atob(post.name) : null;
        }
      }
    );

    const postIDsRaw = await this.connectionService.fetch(this.marshalPostIDUrl);
    const postIDs = parseObjects(postIDsRaw);

    Object.values(postIDs).forEach(
      post => {
        this._marshalPosts[post.ruleid] = this._names[post.refid] || post.refid;
      }
    );


    this.updateZones();
  }

  stop() {
    this._timeout && clearTimeout(this._timeout);
  }

  async updateZones() {
    const url = this.activeZonesUrl + Date.now();
    try {
      const zones = await this.connectionService.fetch(url);
      const zoneData = JSON.parse(zones);

      const flagZones = {};

      (zoneData.data || []).forEach(
        ([zoneType, zone]) => {
          const post = this._marshalPosts[zone];
          flagZones[zone] = {
            post,
            zoneType,
            name: MARSHAL_POST_LOCATIONS[post]
          }
        }
      )

      this.emit('flagZones', flagZones);
    }
    catch (e) {
      console.error(e);
    }

    this._timeout = setTimeout(this.updateZones, 10000);
  }
}
